import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbsProps = {
  items: Crumb[];
};

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="font-mono text-xs">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-background-200">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="transition-colors hover:text-accent-300 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-accent-300 whitespace-nowrap' : ''}>
                  {item.label}
                </span>
              )}
              {!isLast ? <span className="text-background-500">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}